import { Breakpoint, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { FlexContainer } from '../styles';
import { APP_HEADER_LOGO } from 'src/common/constants/brand';
import { layoutConfig } from 'src/common/layout/config';
import { getSubdomain } from 'src/utils/domain/getSubdomain';
import { AppSubdomains } from 'src/types/common';

interface HeaderBrandProps {
  columns?: { [key in Breakpoint]?: number };
  horizontalAlign?: 'center' | 'flex-start';
}

const DEFAULT_COLUMNS = {
  xs: 12,
  md: 1.3,
  xl: 1.3,
};

const renderLogo = () => (
  <Link to="/">
    <img
      width="100%"
      style={{ maxWidth: 110 }}
      src={APP_HEADER_LOGO}
      alt="Logo"
    />
  </Link>
);

export default function HeaderBrand({
  columns,
  horizontalAlign,
}: HeaderBrandProps) {
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const { defaultLayout } = layoutConfig[subdomain];

  return (
    <Grid item {...(columns ?? DEFAULT_COLUMNS)}>
      <FlexContainer
        width="100%"
        justifyContent={{
          xs: horizontalAlign ?? 'center',
          md: horizontalAlign ?? 'flex-start',
        }}
      >
        {defaultLayout.headerBrand && renderLogo()}
      </FlexContainer>
    </Grid>
  );
}
